import { utilsApp } from "./utils-app_v2.js";
import { colors } from "./colors_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { identityService } from "./profile/identityService_v2.js";
import { iPop } from "./ipop_v2.js";
import { newMatch } from "./matches/newMatch_v2.js";
import { events } from "aws-amplify/data";
import { dateTimeUtils } from "./dateTimeUtils_v2.js";
import { rankFormula } from "./profile/rankFormula_v2.js";
import { escapeHtml } from "./escapeHtml_v2.js";

var leaderboardState = {
  size: "small",
  page: 0,
  itemsOnPage: 7,
  totalPages: 1,
  accounts: [],
  connections: [],
  lastUpdate: "",
};

// always in the dom
const leaderboardNav = document.getElementById("leaderboardNav");
const leaderboardSection = document.getElementById("leaderboardSection");

export const render = async (size) => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;
  leaderboardNav.classList.add("sectionNarrow");
  switch (size) {
    case "normal":
      leaderboardState.size = "normal";
      const modalBehinder = document.getElementById("modalBehinder");
      modalBehinder.style.display = "block";
      modalBehinder.dataset.action = "modalBehinderCloseLeader";
      leaderboardSection.style.width = utilsApp.calculateSectionWidth();
      const htmlNormal = `
        <div id="sectionHeaderArea" class="vertical">
          <div id="leaderVert">Leaderboard</div>
        </div>
        <div class="flexColumn" id="leaderContainer">
          <div id="leaderTop100">Top 100<div id="leaderSplainer" class="i">ⓘ</div></div>
          <div id="leaderboardData">
          </div>
          <div class="flexRow" id="leaderboardFooter">
          </div>
        </div>
        <div id="closeLeaderboard" class = "x"></div>
          `;
      leaderboardSection.classList.add("sectionWide");
      leaderboardSection.innerHTML = htmlNormal;
      document.getElementById("leaderboardData").innerHTML =
        leaderboardShimmerHTML();
      colors.setButtonColors();
      utilsApp.adjust4Mobile();

      loadInitialData();
      renderFooter();
      subscribeLeaderboardEvents();
      break;
    case "small":
      leaderboardState.size = "small";
      leaderboardSection.style.width = "0px";
      leaderboardSection.innerHTML = "";
      leaderboardSection.className = "";

      break;
    default:
      console.log(
        "Error: Attempting to render leaderboard to invalid size: " + size,
      );
      return;
  }
  setColorsAndListeners();
};

const leaderboardShimmerHTML = () => {
  let html = ``;
  for (let i = 0; i < leaderboardState.itemsOnPage; i++) {
    html += `  <div class="leaderboardRowContainer flexRow">
              <div class="leaderFlexRow shimmer"></div><button class="button leaderNewMatchButton">New Match</button>
              </div>`;
  }
  return html;
};

const renderFooter = () => {
  const leaderboardFooter = document.getElementById("leaderboardFooter");

  leaderboardFooter.innerHTML = `<div class="prevNext" id="leaderPrevious">Previous</div>
            <div class="prevNext" id="leaderNext">Next</div> (Page ${leaderboardState.page + 1} of ${leaderboardState.totalPages})`;
};

const handleLeaderPrevNext = (event, element) => {
  const gotClicked = element.id;
  if (
    gotClicked === "leaderNext" &&
    leaderboardState.page < leaderboardState.totalPages - 1
  ) {
    leaderboardState.page++;
  }
  if (gotClicked === "leaderPrevious" && leaderboardState.page > 0) {
    leaderboardState.page--;
  }
  renderAccounts();
};

const renderLeaderSplainer = (event) => {
  iPop.render({
    text: `When updates are happening, the board refreshes once per minute.`,
    event,
  });
};

const setColorsAndListeners = () => {
  colors.setNavColors();
};

const handleClose = () => {
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
  render("small");
  unSubscribeLeaderboardEvents();
};

const getSize = () => {
  return leaderboardState.size;
};

const handLeaderboardNavClick = () => {
  render("normal");
};

const loadInitialData = async () => {
  const result = await identityService.getLeaderboardTop();
  if (result.status != 200) {
    return;
  } else {
    leaderboardState.accounts = result.leaderboard.currentTop;
    leaderboardState.lastUpdate = dateTimeUtils.compactDateMMDDYYYY();
    renderAccounts();
  }
};

const renderFormulaSplainer = (event, element) => {
  const gotClicked = element.id;
  const parts = gotClicked.split("#");
  let account = {};
  for (const cachedAccount of leaderboardState.accounts) {
    if (cachedAccount.userID === parts[0]) {
      account = cachedAccount;
    }
  }

  iPop.render({
    text: rankFormula.generateHTML(account),
    event,
  });
};

const generateLeaderCardHTML = (account) => {
  // SECURITY: other users' data, so everything is escaped
  const rank = escapeHtml(account.rank.slice(0, 4));
  const name = escapeHtml(account.name);
  const blurb = account?.blurb ? '"' + escapeHtml(account.blurb) + '"' : "";
  let cardHTML = `<div class="leaderFlexRow">`;
  cardHTML += `<div class="leaderRank noWrap">${rank} <div id="${escapeHtml(account.userID)}#formulaSplainer" class="i">ⓘ</div></div>`;
  cardHTML += `<div class="leaderFlexColumn leaderPlayerName"><div>${name}</div><div class="leaderPlayerBlurb">${blurb}</div></div>`;
  cardHTML += `</div>`;
  eventHub.registerEvent(
    "click",
    `${account.userID}#formulaSplainer`,
    renderFormulaSplainer,
  );
  return cardHTML;
};

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const renderAccounts = async () => {
  document.getElementById("leaderboardData").innerHTML =
    leaderboardShimmerHTML();
  colors.setButtonColors();
  await delay(1000);
  const accounts = leaderboardState?.accounts ?? 0;
  const page = leaderboardState?.page ?? 1;
  const itemsOnPage = leaderboardState?.itemsOnPage ?? 5;
  const startIndex = page * itemsOnPage;
  let endIndex = accounts.length;
  if (endIndex > startIndex + itemsOnPage) {
    endIndex = startIndex + itemsOnPage;
  }
  const totalPages = Math.ceil(accounts.length / itemsOnPage);
  leaderboardState.totalPages = totalPages;

  var rowsHTML = "";
  for (let i = startIndex; i < endIndex; i++) {
    const leaderCardHTML = generateLeaderCardHTML(accounts[i]);
    const buttonID = `leader-${accounts[i].userID}`;
    let row2Add = `<div class="leaderboardRowContainer flexRow">`;
    row2Add += leaderCardHTML;
    row2Add += `<button id="${buttonID}" class="button leaderNewMatchButton">New Match</button>`;
    row2Add += `</div>`;
    rowsHTML += row2Add;
    eventHub.registerEvent("click", buttonID, handleLeaderNewMatch);
    //eventHub.registerEvent("pointerover", buttonID, handlePointerOver);
    //eventHub.registerEvent("pointerout", buttonID, handlePointerOut);
  }
  document.getElementById("leaderboardData").innerHTML = rowsHTML;
  const leaderboardRows = document.getElementsByClassName(
    "leaderboardRowContainer",
  );
  for (const row of leaderboardRows) {
    row.style.backgroundColor = colors.getGameColor("tip");
  }
  colors.setButtonColors();
  renderFooter();
};

const handleLeaderNewMatch = (event, element) => {
  const userID = element.id.slice(7);

  for (const account of leaderboardState.accounts) {
    if (userID === account.userID) {
      const params = {
        sendToModule: "newMatch",
        player: "newSearchP1",
        name: account.name,
      };
      handleClose();
      newMatch.setInviteeName(params);
    }
  }
};

const handlePointerOver = (event, element) => {
  element.classList.add("shadow");
  element.style.background = colors.getGameColor("iPop");
};

const handlePointerOut = (event, element) => {
  element.classList.remove("shadow");
  element.style.background = colors.getGameColor("lighterAccent");
};

const subscribeLeaderboardEvents = async () => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const token =
    "Bearer " +
    utilsApp.base64UrlEncode(pAIdentityResponse.identity.identityToken);
  const connection = await events.connect("leaderboard/default", {
    authMode: "lambda",
    authToken: token,
  });

  const subscription = connection.subscribe({
    next: async (message) => {
      const messageReceived = await message.event;

      leaderboardState.accounts = JSON.parse(messageReceived.data);
      leaderboardState.lastUpdate = messageReceived.lastUpdate;

      renderAccounts();
    },
    error: async (err) => {
      console.error("leaderboard/default subscription error:", await err);
      console.log(err.message);
    },
  });

  // keep track of it
  leaderboardState.connections.push({
    connection: connection,
    subscription: subscription,
  });
};

const unSubscribeLeaderboardEvents = () => {
  if (leaderboardState?.connections.length > 0) {
    for (const connection of leaderboardState.connections) {
      connection.subscription.unsubscribe();
      connection.connection.close();
    }
  }
  leaderboardState.connections = [];
};

eventHub.registerEvent("click", "leaderSplainer", renderLeaderSplainer);
eventHub.registerEvent("click", "leaderboardNav", handLeaderboardNavClick);
eventHub.registerEvent("click", "modalBehinderCloseLeader", handleClose);
eventHub.registerEvent("click", "closeLeaderboard", handleClose);

eventHub.registerEvent("pointerover", "leaderPrevious", handlePointerOver);
eventHub.registerEvent("pointerout", "leaderPrevious", handlePointerOut);
eventHub.registerEvent("click", "leaderPrevious", handleLeaderPrevNext);

eventHub.registerEvent("pointerover", "leaderNext", handlePointerOver);
eventHub.registerEvent("pointerout", "leaderNext", handlePointerOut);
eventHub.registerEvent("click", "leaderNext", handleLeaderPrevNext);

export const leaderboard = {
  render,
  getSize,
};
